import React, { useState, useEffect } from "react";
import EnquiredPropertyCard from "./EnquiredPropertyCard";
import { getAllProperties, getBidInterest } from "services";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
} from "@reusejs/react";
import { useSelector } from "react-redux";

let sectionDetails = {
  title: "Enquired assets",
  description: "",
};

export default function EnquiredProperties() {
  const [propertiesData, setPropertiesData] = useState([]);

  const userUuid = useSelector((state: any) => {
    return state.auth?.user?.uuid;
  });

  useEffect(() => {
    if (userUuid) {
      init(userUuid);
    }
  }, [userUuid]);

  const init = async (uuid: any) => {
    try {
      const data: any = await getBidInterest(uuid);
      if (data) {
        const propertiesUuid = data.map((item: any) => {
          return item.property_uuid;
        });

        if (propertiesUuid.length > 0) {
          const properties: any = await getAllProperties({
            apiConfig: {
              includeRelations: ["city", "sub_asset_type", "bank", "images"],
              includeMutations: ["state", "asset", "images"],
              includeFacets: false,
            },
            limitBy: {
              per_page: 10,
              page: 1,
            },
            sortBy: [{ attribute: "created_at", order: "asc" }],
            filterBy: [
              {
                attribute: "uuid",
                op: "in",
                value: propertiesUuid,
              },
            ],
          });
          if (properties.data.length > 0) {
            const formattedProperties: any = formattedData(
              data,
              properties.data
            );

            setPropertiesData(formattedProperties);
          }
        }
      }
    } catch (error) {
      console.log("check error", error);
    }
  };

  const formattedData = (data: any, array: any) => {
    return data.map((obj: any) => {
      const foundProperty: any = array.find(
        (item: any) => item.uuid === obj.property_uuid
      );

      if (foundProperty) {
        return {
          ...obj,
          property: foundProperty,
        };
      }
    });
  };

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-white overflow-hidden py-10 md:py-10",
        innerContainerStyles: "max-w-7xl",
      }}
    >
      <IconTitleDescriptionActionCard
        title={sectionDetails.title}
        description={sectionDetails.description}
        itemTitleDescriptionCardBaseClasses={{
          titleWrapper: "text-left",
          titleStyles:
            "text-2xl font-extrabold text-gray-900 sm:leading-none sm:tracking-tight",
          descriptionWrapper: "text-left mt-4 ",
          descriptionStyles: "max-w-2xl text-base text-gray-500",
        }}
      />

      <div className="mt-10 h-full space-y-4">
        {propertiesData &&
          propertiesData.map((item: any, index) => (
            <EnquiredPropertyCard property={item} key={index} />
          ))}
      </div>
    </SectionContainerBase>
  );
}
